<default-popup-wrapper-component #wrapper [componentRef]="this" [globalPopup]="globalPopup" [hideCloseButton]="!canIgnorePopup" [showLoader]="isLoading" [title]="this.ts.translate('2fa.popup-title')" (onClose)="closePopup($event)">
    <div class="intro" [innerHTML]="'2fa.popup-intro' | translate"></div>
    <form [formGroup]="userForm" class="mt-4">
        <div class="row current-data py-3">
            <div class="col-12">
                <h2>{{'2fa.popup-current-data-title' | translate}}</h2>
            </div>
            <div class="col-12 col-md-6">
                <label class="w-100">
                    {{'2fa.popup-old-username-label' | translate}}
                    <input type="text" formControlName="currentUsername"/>
                </label>
            </div>
            <div class="col-12 col-md-6">
                <label class="w-100">
                    {{'2fa.popup-old-email-label' | translate}}
                    <input type="text" formControlName="currentEmail" />
                </label>
            </div>
        </div>
        <div class="row new-data py-3 mt-4">
            <div class="col-12">
                <h2>{{'2fa.popup-new-data-title' | translate}}</h2>
            </div>
            <div class="col-12 col-md-6">
                <label class="w-100">
                    {{'2fa.popup-new-email-label' | translate}}
                    <input type="text" class="w-100" formControlName="newEmail" />
                </label>
            </div>
        </div>
        <ng-container *ngIf="hasSendEmail && !isCodeCorrect">
            <h2 class="mt-4">{{'2fa.popup-2fa-title' | translate}}</h2>
            <div class="twofa-intro" [innerHTML]="'2fa.popup-2fa-intro' | translate"></div>
            <div class="col-12 col-md-6 p-0">
                <div formArrayName="code" class="d-flex justify-content-start gap-2">
                    <input
                        type="text"
                        style="position:absolute;opacity:0;pointer-events:none;"
                        autocomplete="one-time-code"
                        (input)="onPaste($event)"
                        (paste)="onPaste($event)"
                    />
                    <ng-container *ngFor="let ctrl of codeControls; let i = index">
                        <input
                            #otpInput
                            type="text"
                            maxlength="1"
                            [formControlName]="i"
                            [name]="'ctrl'+i"
                            class="otp-input form-control text-center mr-1"
                            (input)="onInput($event, i)"
                            (keydown)="onKeyDown($event, i)"
                            (paste)="onPaste($event)"
                        />
                    </ng-container>
                </div>
            </div>
            <ng-container *ngIf="!isCodeCorrect">
                <div class="small" *ngIf="timeTillEmailResend > 0" [innerHTML]="'2fa.email-has-been-send' | translate:[timeTillEmailResend]"></div>
                <div class="small twofa-popup-link-text" *ngIf="timeTillEmailResend === 0" [innerHTML]="'2fa.popup-resend-mail' | translate" (click)="resendEmail()"></div>
            </ng-container>
        </ng-container>

        <div class="form-output">
            <div class="bg-success text-white border rounded p-2 mt-4" *ngIf="hasSendCode && isCodeCorrect">
                {{'2fa.popup-code-success' | translate}}
            </div>
            <div class="bg-danger text-white border rounded p-2 mt-4" *ngIf="hasSendCode && !isCodeCorrect">
                {{'2fa.popup-code-fail' | translate}}
            </div>
            <div class="bg-danger text-white border rounded p-2 twofa-form-error" *ngIf="formError != ''" [innerHTML]="formError"></div>
        </div>
    </form>
    <div class="action d-flex mt-4 justify-content-end">
        <lumi-button
                *ngIf="!this.isCodeCorrect && canIgnorePopup"
                [label]="'close' | translate"
                [rank]="'tertiary'"
                [size]="'large'"
                (click)="closePopup($event)"
        ></lumi-button>
        <lumi-button
                [label]="saveButtonLabel"
                [rank]="'primary'"
                [size]="'large'"
                [disabled]="userForm.invalid"
                (click)="sendCode()"
        ></lumi-button>
    </div>
</default-popup-wrapper-component>
